/**
 * Starts the background thread the image is traced on.
 *
 * On its own because `import.meta` is how the bundler finds the thread's code, and the test
 * runner cannot read it: everything that uses a thread is tested with this replaced.
 */
export const createTraceWorker = (): Worker => new Worker(new URL('./trace.worker.ts', import.meta.url));

export default createTraceWorker;
